import { defineComponent as a, resolveComponent as t, openBlock as r, createBlock as o, withCtx as s, createCommentVNode as l, createTextVNode as d, toDisplayString as u } from "vue";
import { V as p } from "../../../VImage-b57fd9d1.js";
import m from "../VLink/VLink.js";
import { _ as c } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../composables/useSpacingClass.js";
import "../../../utils/isExternalUrl.js";
const y = a({
  name: "VStyledLink",
  components: { VLink: m, VImage: p },
  props: {
    styledLink: {
      type: Object,
      default: () => ({}),
      required: !0
    },
    buttonSize: {
      type: String,
      default: "",
      validator(e) {
        return ["", "small", "widget-small", "big"].indexOf(e) !== -1;
      }
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  },
  computed: {
    order() {
      switch (this.styledLink.style) {
        case "orangeFilled":
          return "primary";
        case "whiteFilled":
          return "secondary";
        case "orangeOutlined":
          return "quaternary";
        default:
          return "primary";
      }
    }
  }
});
function _(e, f, k, g, h, L) {
  const n = t("VImage"), i = t("VLink");
  return r(), o(i, {
    class: "hobi-link hobi-styled-link",
    href: e.styledLink.url,
    type: "button",
    "button-size": e.buttonSize,
    order: e.order,
    router: e.router
  }, {
    default: s(() => [
      e.styledLink.icon ? (r(), o(n, {
        key: 0,
        image: e.styledLink.icon,
        class: "hobi-styled-link__icon",
        role: "presentation",
        height: "16px"
      }, null, 8, ["image"])) : l("", !0),
      d(" " + u(e.styledLink.title), 1)
    ]),
    _: 1
  }, 8, ["href", "button-size", "order", "router"]);
}
const C = /* @__PURE__ */ c(y, [["render", _], ["__scopeId", "data-v-13e3a5a4"]]);
export {
  C as default
};
